export const Separator = () => {
  return (
    <div className="border-border my-[52px] h-[1px] w-full border-t-[1px] border-solid" />
  );
};
